import './style.scss'
import { useNavigate } from "react-router-dom"
import { IoIosArrowBack, IoIosStar, IoIosStarOutline } from "react-icons/io"
import { AppSpan, AppText, Circle, CustomContainer, FlexRow, PageTitle, PageWrapper } from "src/style"
import utility from "src/utils/utility"
import helpers from "src/utils/helpers"

const ProductComments = () => {
    const navigate = useNavigate()

    return (
        <PageWrapper>
            <FlexRow 
                width="auto" sizeUnit="" 
                gap="1" bottomPadding="2.5"
                style={{borderBottom: "1px solid #EAECF0"}}
                onClick={() => navigate(-1)}
            >
                <AppSpan textSize='2.5' cursor='pointer' bottomMargin='1' >
                    <IoIosArrowBack />
                </AppSpan>
                <PageTitle 
                    color='#101828' textSize='3' fontWeight="500"
                >
                    Comments
                </PageTitle>
            </FlexRow>
            <CustomContainer topMargin="3.5">
                <FlexRow 
                    justifyContent="space-between" 
                    gap="2" wrap="wrap"
                >
                    {
                        comments?.map((item, index) => {
                            const [firstName, lastName] = item.fullName?.split(' ')
                            return (
                                <CustomContainer 
                                    key={index} topMargin="1.5" 
                                    width="48" sizeUnit="%"
                                    className="comment-container"
                                >
                                    <FlexRow gap="1">
                                        <Circle size="4" bgColor='#0D968F'>
                                            <AppSpan color="#F7F8F9" fontWeight="600">{firstName[0]}{lastName[0]}</AppSpan>
                                        </Circle>
                                        <AppSpan color="#3A3A3A" fontWeight="500">{item.fullName}</AppSpan>
                                    </FlexRow>
                                    <FlexRow gap="1" topMargin="1" wrap="wrap">
                                        <FlexRow width="auto" sizeUnit="" gap="0.5">
                                            {
                                                Array.from(Array(5).keys())?.map((num: number) => {
                                                    return (
                                                        num <= (item?.rating - 1) ?
                                                            <IoIosStar fill='#409089' fontSize='1.4rem' key={num} />
                                                            : <IoIosStarOutline fill='#344054' fontSize='1.4rem' key={num} />
                                                    )
                                                })
                                            }
                                        </FlexRow>
                                        <AppSpan color="#3A3A3A" textSize="1.2">
                                            {item.date ? helpers.handleDate(item.date) : null}
                                        </AppSpan>
                                    </FlexRow>
                                    <AppText topMargin="1">{item.comment}</AppText>
                                </CustomContainer>
                            )
                        })
                    }
                </FlexRow>
            </CustomContainer>
        </PageWrapper>
    )
}

export default utility.routeData('product/:productId/comments', 'Product Comments', <ProductComments/>)


const comments = [
    {
        fullName: 'Iyin Laditan',
        rating: 4,
        comment: 'Amazing!!!',
        date: '2024-08-02T16:55:23.957Z'
    },
    {
        fullName: 'Ridwan Kolawole',
        rating: 3,
        comment: 'Amazing!!!',
        date: '2024-08-02T16:55:23.957Z'
    },
    {
        fullName: 'Iyin Laditan',
        rating: 4,
        comment: 'Amazing!!!',
        date: '2024-08-02T16:55:23.957Z'
    },
    {
        fullName: 'Ridwan Kolawole',
        rating: 3,
        comment: 'Amazing!!!',
        date: '2024-08-02T16:55:23.957Z'
    },
    {
        fullName: 'Iyin Laditan',
        rating: 4,
        comment: 'Amazing!!!',
        date: '2024-08-02T16:55:23.957Z'
    },
    {
        fullName: 'Ridwan Kolawole',
        rating: 3,
        comment: 'Amazing!!!',
        date: '2024-08-02T16:55:23.957Z'
    }
]